import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { Post, PostRequest, PostResponse } from 'Models/post'
import Pagination from 'Models/pagination'
import service from '../Services'
import useEventStore from 'Store/eventStore'
import useUserStore from 'Store/userStore'

interface State {
      posts: Post[]
      likes: number[]
      init: () => void
      addPost: (active: PostRequest) => void
      getPosts: () => void
      getFavoritePosts: () => Post[]
      loading: boolean
      addingPost: boolean
      setAddingPost: (flag: boolean) => void
      pagination: Pagination
}

// const postStore = (set, get) => ({
export const usePostStore = create<State>(
      (set, get): State => ({
            posts: [],
            likes: [],
            pagination: {
                  meta: {
                        count: 0,
                        current_page: 0,
                        per_page: 0,
                        total: 0,
                        total_pages: 0,
                  },
            },
            init: async () => {
                  set(() => ({
                        posts: [],
                        likes: [],
                        pagination: {
                              meta: {
                                    count: 0,
                                    current_page: 0,
                                    per_page: 0,
                                    total: 0,
                                    total_pages: 0,
                              },
                        },
                  }))
            },
            addPost: async (body: PostRequest) => {
                  try {
                        // get().setAddingPost(true)
                        set(() => ({ addingPost: true }))
                        // const { selectedEvent } = useEventStore.getState()
                        // const { user } = useUserStore.getState()
                        // const body: PostRequest = {
                        //   ...post,
                        //   creator: user?.name,
                        //   social_event_id: selectedEvent,
                        // }
                        const newPost = await service.addPost(body)
                        if (newPost) {
                              set((state: State) => ({
                                    posts: [{ ...newPost }, ...state.posts],
                              }))
                        } else {
                              throw new Error('Failed to add post')
                        }
                  } catch (error) {
                        console.error('Error adding post:', error)
                  } finally {
                        // get().setAddingPost(false)
                        set(() => ({ addingPost: false }))
                  }
            },
            getPosts: async () => {
                  try {
                        set({ loading: true })
                        const { event } = useEventStore.getState()
                        const { user } = useUserStore.getState()
                        if (event) {
                              const body = {
                                    socialEvent: event.id,
                                    page: get().pagination?.meta?.current_page + 1,
                              }
                              const response: PostResponse = await service.getPosts(body)
                              const newPosts: Post[] = response.posts
                              if (newPosts) {
                                    set((state: State) => ({
                                          posts: [...state.posts, ...newPosts],
                                          likes: user
                                                ? newPosts
                                                        .map((post) => {
                                                              if (
                                                                    post.likes.users
                                                                          .map((u) => u.name)
                                                                          .includes(user?.name)
                                                              ) {
                                                                    return post.id
                                                              }
                                                        })
                                                        .filter((p) => p > 0)
                                                : [],
                                          pagination: {
                                                meta: response.meta,
                                                links: response.links,
                                          },
                                    }))
                              } else {
                                    throw new Error('Failed to add post')
                              }
                        } else {
                              throw new Error('No event id provided')
                        }
                  } catch (error) {
                        console.error('Error fetching posts:', error)
                  } finally {
                        set({ loading: false })
                  }
            },
            getFavoritePosts: async (): Promise<Post.Post[]> => {
                  try {
                        set(() => ({
                              loading: true,
                        }))
                        const { user } = useUserStore.getState()
                        if (user) {
                              const simplePosts = get().posts

                              const favoritePosts = simplePosts.filter((p) =>
                                    get().likes.includes(p.id)
                              )
                              // const favoritePosts = simplePosts.filter((post: Post.Post) => {
                              //   return post.likes.users.map((u) => u.name).includes(user.name)
                              // })

                              return favoritePosts
                        }
                        return []
                  } catch (error) {
                        console.error('Error fetching posts:', error)
                        return []
                  } finally {
                        set(() => ({
                              loading: false,
                        }))
                  }
            },
            deletePost: async (postId: number) => {
                  try {
                        const post: Post.Post = await service.deletePost(postId)
                        if (post) {
                              const posts = [...get().posts]
                              const index = posts.findIndex((post: Post.Post) => post.id === postId)
                              if (index > -1) {
                                    posts.splice(index, 1)
                              }
                              set(() => ({
                                    posts: posts,
                              }))
                        } else {
                              throw new Error('Failed to add post')
                        }
                  } catch (error) {
                        console.error('Error fetching posts:', error)
                  }
            },
            like: async (postId: number) => {
                  try {
                        const { user } = useUserStore.getState()
                        const likesArray = [...get().likes]
                        const newLikes: number[] = likesArray
                        if (likesArray.includes(postId)) {
                              const index = likesArray.findIndex((l) => l == postId)
                              likesArray.splice(index, 1)
                        } else {
                              likesArray.push(postId)
                        }

                        const likedPost: Post.Post = get().posts.find((p) => p.id === postId)

                        let updatedLikes: Post.Likes = likedPost.likes
                        if (get().likes.includes(postId)) {
                              const usersWithoutMe = likedPost.likes.users.filter(
                                    (u) => u.name !== user?.name
                              )
                              updatedLikes = {
                                    count: likedPost.likes.count - 1,
                                    users: usersWithoutMe,
                              }
                        } else {
                              updatedLikes = {
                                    count: likedPost.likes.count + 1,
                                    users: [...likedPost.likes.users, { name: user.name }],
                              }
                        }

                        likedPost.likes = updatedLikes

                        const posts = get().posts
                        const likedPostIdx = posts.findIndex((p) => p.id === postId)
                        posts[likedPostIdx] = likedPost

                        set(() => ({
                              posts: posts,
                              likes: newLikes,
                        }))
                        const updatedPost = await service.like(postId)
                        if (updatedPost?.likes_counter >= 0) {
                              return updatedPost.likes_counter
                        } else {
                              throw new Error('Failed to make like')
                        }
                  } catch (error) {
                        console.error('Error making like:', error)
                  }
            },
            addComment: async (postId: number, content: string) => {
                  try {
                        const updatedPost: Post.Post = await service.addComment(postId, {
                              content: content,
                        })
                        if (updatedPost?.comments) {
                              return updatedPost.comments
                        } else {
                              throw new Error('Failed to add comment')
                        }
                  } catch (error) {
                        console.error('Error adding comment:', error)
                  }
            },
            loading: false,
            addingPost: false,
            setAddingPost: (flag: boolean) => {
                  set(() => ({
                        addingPost: flag,
                  }))
            },
      })
)

// const usePostStore = create(devtools(postStore))

export default usePostStore
